import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
  `,
  wrapper: css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-bottom: 4px;
  `,
  separator: css`
    font-size: 14px;
    color: ${colors.charcoal};
    padding: 0px 4px 0px 4px;
  `,
  iconSearch: css`
    color: ${colors.charcoal} !important;
  `,
  adjustArea: css`
    text-decoration: underline !important;
    cursor: pointer;
  `,
  schoolsContainer: css`
    text-align: center;
  `,
};

export default styles;
